import sanitizeHtmlLib from 'sanitize-html';

// Sanitizes author/API-sourced HTML before it is assigned via dangerouslySetInnerHTML or innerHTML.
// sanitize-html is a pure JS/htmlparser2-based sanitizer (no DOM dependency), so it behaves
// identically during SSR (Node) and on the client without pulling Node-only deps into the browser bundle.
export function sanitizeHtml(html?: string): string {
  if (!html) {
    return '';
  }
  return sanitizeHtmlLib(html, {
    allowedTags: sanitizeHtmlLib.defaults.allowedTags.concat(['span', 'img']),
    allowedAttributes: {
      ...sanitizeHtmlLib.defaults.allowedAttributes,
      img: ['src', 'alt', 'width', 'height', 'style'],
    },
  });
}
